<app-page-layout>
  <app-page-bar>
    <app-bar-back-button [link]="['/']"
                         [tooltip]="'Главная'"></app-bar-back-button>
    <app-bar-title>Профиль</app-bar-title>
  </app-page-bar>
  <app-page-content [narrow]="true">

    <div class="properties" *ngIf="user">
      <div class="property">
        <div class="name">ФИО:</div>
        <div class="value">{{formatFullFio()}}</div>
      </div>
      <div class="property">
        <div class="name">Почта:</div>
        <div class="value">{{user.mail}}</div>
      </div>
      <div class="property">
        <div class="name">Зарегистрирован:</div>
        <div class="value">
          <app-time-event [value]="user.registerDate"></app-time-event>
        </div>
      </div>
      <div class="property">
        <div class="name">Роли:</div>
        <div class="value">{{formatRoles()}}</div>
      </div>
    </div>

    <div class="actions">
      <button mat-raised-button color="primary"
              (click)="openMeChangePasswordDialog()">Изменить пароль
      </button>
    </div>

  </app-page-content>
</app-page-layout>
